import CrossIcon from '@atlaskit/icon/glyph/cross';
import LockIcon from '@atlaskit/icon/glyph/lock';
import { LinkButton } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { InfoList, InfoListItem, InfoListItemContent, InfoListItemIcon, ItemDescription } from '../styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PrivacySecurityQuestionnaireStatus = props => {
  const {
    privacySecurityQuestionsState
  } = props;
  if (privacySecurityQuestionsState === 'not_applicable' || privacySecurityQuestionsState === 'loading') {
    return null;
  }
  const {
    questionnaireFilled,
    onViewResponsesClick
  } = privacySecurityQuestionsState;
  return /*#__PURE__*/_jsx(InfoList, {
    children: /*#__PURE__*/_jsxs(InfoListItem, {
      children: [/*#__PURE__*/_jsx(InfoListItemIcon, {
        children: questionnaireFilled ? /*#__PURE__*/_jsx(LockIcon, {
          label: "",
          size: "medium"
        }) : /*#__PURE__*/_jsx(CrossIcon, {
          label: "",
          size: "medium"
        })
      }), /*#__PURE__*/_jsxs(InfoListItemContent, {
        children: [/*#__PURE__*/_jsx(ItemDescription, {
          children: questionnaireFilled ? 'Privacy and security questionnaire has been filled by the partner' : 'Privacy and security questionnaire has not been filled by the partner'
        }), questionnaireFilled && /*#__PURE__*/_jsx(LinkButton, {
          onClick: onViewResponsesClick,
          children: "Read the responses"
        })]
      })]
    })
  });
};